import * as React from 'react';
import { useState } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import Button from '../../../../components/Button';
import Modal from '../../../../components/Modal';

import './style.scss';

const ListSection = () => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <section className="l-list-section">
      <div className="container">
        <h2 className="section-title">Root cause analysis as a risk management tool</h2>
        <p>
          To encourage and assist associations, the Councils have provided guidance to incorporate root cause analysis
          into their risk management strategies.
        </p>

        <div className="list">
          <ol>
            <li data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease">
              <div>
                <span data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease">
                  Identify trends from data
                </span>
              </div>
            </li>
            <li data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease">
              <div>
                <span data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease">
                  Implement root cause analysis using data sources
                </span>
              </div>
            </li>
            <li data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease">
              <div>
                <span data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease">
                  Formulate risk management responses that target the identified root causes
                </span>
              </div>
            </li>
            <li data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease">
              <div>
                <span data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease">
                  Monitor data and evaluate risk management strategies
                </span>
              </div>
            </li>
          </ol>
        </div>

        <div data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease">
          <Button label="View more" color="secondary" icon="plus" onClick={() => setModalOpen(true)} />
          <Modal type="image" isOpen={modalOpen} close={() => setModalOpen(false)}>
            <StaticImage
              src="./assets/root-cause-analysis.png"
              alt="Incorporating root cause analysis into risk management strategies"
            />
            <div className="sr-only">
              <p>Ask the WHYs</p>
              <ol>
                <li>Identify trends from data, e.g. the data identified a 20% increase in negligence claims</li>
                <li>
                  Implement root cause analysis using data sources
                  <ul>
                    <li>Cause of action, wy did the negligence occur?</li>
                    <li>
                      Practitioners taking on work beyond their expertise / capability, why are they taking on work in
                      areas beyond their expertise / capability?
                    </li>
                    <li>Lack of supervision of junior employees, why is there a lack of supervision?</li>
                    <li>COVID-19 working from home arrangements</li>
                  </ul>
                </li>
                <li>
                  Formulate risk management responses that target the identified root causes
                  <ul>
                    <li>Member audit / engagement systems</li>
                    <li>CPD courses</li>
                    <li>Issuing guidance to members and consumers</li>
                  </ul>
                </li>
                <li>
                  Monitor data and evaluate risk management strategies, e.g. Consider the following questions
                  <ul>
                    <li>What were your risk management strategy measures? How did they perform?</li>
                    <li>Do you see a difference in data obtained during the next period?</li>
                    <li>Can you identify any alternative responses that can be more effective?</li>
                    <li>How are you ensuring the risk management strategy is continuously improved?</li>
                  </ul>
                </li>
              </ol>

              <p>Sources:</p>
              <ul>
                <li>Complaints data</li>
                <li>Claims data</li>
                <li>Member surveys</li>
                <li>Reports</li>
                <li>Reports</li>
                <li>Media articles</li>
              </ul>
            </div>
          </Modal>
        </div>
      </div>
    </section>
  );
};

export default ListSection;
